import store from "store";
import { aesDecrypt } from "@/utils/utils";

export function login() {
  return new Promise((resolve, reject) => {
    wx.login({ success: resolve, fail: reject });
  });
}

export function getWxUserInfo() {
  return new Promise((resolve, reject) => {
    wx.getUserInfo({ success: resolve, fail: reject });
  });
}

export function setStorage(key, value) {
  store.set(key, value);
}

export function getStorage(key) {
  var value = store.get(key)
  if (value) {
    if(key == 'user'){
      if(value.mobile&&value.mobile.length>20){
        value.mobile = aesDecrypt(value.mobile)
      }
      if(value.idNo&&value.idNo.length>20){
        value.idNo = aesDecrypt(value.idNo)
      }
    }
  }
  return value
}

export function removeStorage(key) {
  return store.remove(key);
}

export function getLocation(cb) {
  var _this = this;
  wx.ready(function () {
    wx.getLocation({
      type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        console.log(res);
        cb && cb(res);
      },
      fail: function (er) {
        console.log(er);
      },
      complete: function (data) {
        console.log(data);
      }
    });
  });
}
export function openLocation(obj) {
  var lat = obj.latitude;
  var lng = obj.longitude;
  var name = obj.name;
  var address = obj.address;

  wx.ready(function (r) {

    wx.openLocation({
      latitude: Number(lat), // 纬度，浮点数，范围为90 ~ -90  
      longitude: Number(lng), // 经度，浮点数，范围为180 ~ -180。  
      name: name, // 位置名
      address: address, // 地址详情说明
      scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大  
      infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转（测试好像不可用）  
      complete: (res)=> {
        console.log(res)
      }
    });
  })
}
export function getUrl() {
  let url = localStorage.getItem("autherUrl");

  return url;
}

export function setUrl(url) {
  let value = url;

  localStorage.setItem("autherUrl", value);
}


// WEBPACK FOOTER //
// ./src/utils/wxuser.js